import Vue from 'vue';
import App from './App.vue';
import store from './plugins/vuex.mongo';
import { router } from './router';
import vuetify from './plugins/vuetify';
import veevalidate from './plugins/veevalidate';
// import VueSocketIO from 'vue-socket.io';

Vue.config.productionTip = false;

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: process.env.VUE_APP_DATENIGHT_BUS_MONGO_FUNCTIONS_URL,
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   }
// }));

const vm = new Vue({
  render: (h) => h(App),
  router,
  store,
  veevalidate,
  vuetify
}).$mount('#app');

export { vm };